// src/data/skills.js

export const SKILL_CATEGORIES = [
  {
    category: 'Programming Languages',
    skills: [
      { name: 'Python',      image: 'skill_images/python.png' },
      { name: 'C',           image: 'skill_images/c.png' },
      { name: 'C++',         image: 'skill_images/cplus.png' },
      { name: 'Java',        image: 'skill_images/java.png' },
      { name: 'JavaScript',  image: 'skill_images/js.png' },
      { name: 'TypeScript',  image: 'skill_images/ts.png' },
    ],
  },
  {
    category: 'Frameworks & Libraries',
    skills: [
      { name: 'React',     image: 'skill_images/react.png' },
      { name: 'Express',      image: 'skill_images/express.png' },
      { name: 'Angular',      image: 'skill_images/angular.png' },
      { name: 'Spring Boot',  image: 'skill_images/spring.png' },
      { name: 'TensorFlow',   image: 'skill_images/tensor.png' },
      { name: 'Django',       image: 'skill_images/django.png' },
      { name: 'PyTorch',      image: 'skill_images/pytorch.png' },
      { name: 'Node.js',      image: 'skill_images/node.png' },
    ],
  },
  {
    category: 'Databases',
    skills: [
      { name: 'MySQL',      image: 'skill_images/mysql.png' },
      { name: 'Firebase',   image: 'skill_images/firebase.png' },
    ],
  },
  {
    category: 'Tools, Platforms & Cloud',  // merged category
    skills: [
      { name: 'Git',    image: 'skill_images/git.png' },
      { name: 'AWS',    image: 'skill_images/aws.png' },
      { name: 'Blender',   image: 'skill_images/blender.png' },
    ],
  },
];
